import apiClient from './apiClient.js';

const AuthService = {
     login(correo, contraseña) {
       return apiClient.post('/usuarios/login/', {
           correo: correo,
           contraseña: contraseña
       });
   },
   logout() {
        return apiClient.post('/usuarios/logout/'); 
    }
 }

  export default AuthService;